export const formattedCurrency = (value) => {
    if (value) {
        return 'Rp' + new Intl.NumberFormat('id-ID', {}).format(value);
    }

    return 'Rp0';
};
